/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

/*
 * action types
 */
import {Util} from "../Utilities.js";

export const ADD_TODO = 'ADD_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER';

export const ERROR = 'ERROR';
export const WARNING = 'WARNING';
export const INFO = 'INFO';
export const MARKASREAD = 'MARKASREAD';
export const ADD_NEW_ERROR_PATH = 'ADD_NEW_ERROR_PATH';
export const REMOVE_ERROR_PATH = 'REMOVE_ERROR_PATH';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const SET_TAB_SELECTION = 'SET_TAB_SELECTION';
export const STORE_VARIABLES = 'STORE_VARIABLES';
// UIGenerator
export const ADD_NEW_UI_ELEMENT = 'ADD_NEW_UI_ELEMENT';
export const UPDATE_UI_ELEMENT_STATE = 'UPDATE_UI_ELEMENT_STATE';
export const REMOVE_UI_ELEMENT = 'REMOVE_UI_ELEMENT';
// layout session
export const UPDATE_LAYOUT_SESSION = 'UPDATE_LAYOUT_SESSION';


/*
 * other constants
 */
export const VisibilityFilters = {
    SHOW_ALL: 'SHOW_ALL',
    SHOW_COMPLETED: 'SHOW_COMPLETED',
    SHOW_ACTIVE: 'SHOW_ACTIVE'
};

/*
 * action creators
 */
export function addTodo(text) {
    return {type: text.type, text}
}


export function toggleTodo(index) {
    return {type: TOGGLE_TODO, index}
}

export function setVisibilityFilter(filter) {
    return {type: SET_VISIBILITY_FILTER, filter}
}


// Error Handling

/**
 * Mark a message by its id as read
 * @param {Object} input
 * @param {string} input.messageId
 * @return {{environment: string, data, isRead: boolean, id: (*|string), type: string, timestamp: number}}
 */
export function markAsRead(input) {
    return {type: MARKASREAD, data: input}
}

export function triggerError(input) {

    return {
        id: Util.unique.newInternalId(),
        type: ERROR,
        data: input,
        timestamp: Math.floor(Date.now() / 1000),
        environment: process.env.NODE_ENV,
        isRead: false
    }
}

export function triggerWarning(input) {

    return {
        id: Util.unique.newInternalId(),
        type: WARNING,
        data: input,
        timestamp: Math.floor(Date.now() / 1000),
        environment: process.env.NODE_ENV,
        isRead: false
    }
}


export function triggerInfo(input) {

    return {
        id: Util.unique.newInternalId(),
        type: INFO,
        data: input,
        timestamp: Math.floor(Date.now() / 1000),
        environment: process.env.NODE_ENV,
        isRead: false
    }
}

export function removeError(errorSourcePath) {
    return {
        type: REMOVE_ERROR,
        data: errorSourcePath,
    }
}

// API caching

export function saveData(name, isLoaded, data) {
    return {type: name, data: data, isLoaded: isLoaded}
}

// Variable Store

export function storeVariable(Name, Value, Prefix) {

    return {type: STORE_VARIABLES, Name: Name, Value: Value, Prefix: Prefix}
}


// Error Array

export function addErrorArray(data) {
    return {type: ADD_NEW_ERROR_PATH, data: data}
}

export function removeErrorArray(data) {
    return {type: REMOVE_ERROR_PATH, data: data}
}

// Tab storage

export function storeNewTabSelection(activeTabKeys) {
    return {type: SET_TAB_SELECTION, data: activeTabKeys}
}

// UIGenerator

export function addNewUIElement(uiId, elementType, content, callbackOnClose, settings) {
    return {
        type: ADD_NEW_UI_ELEMENT,
        uiId: uiId,
        elementType: elementType,
        content: content,
        callbackOnClose: callbackOnClose,
        settings: settings,
        openTime: Util.time.now()
    }
}

export function updateUIElementState(uiId, newState) {
    return {type: UPDATE_UI_ELEMENT_STATE, uiId: uiId, newState: newState}
}

export function removeUIElement(uiId) {
    return {type: REMOVE_UI_ELEMENT, uiId: uiId}
}


// layout session
export function updateLayoutSession(newSessionData) {
    return {type: UPDATE_LAYOUT_SESSION, sessionData: newSessionData}
}
